import { graphql } from "../generated";

export const UNBOOKMARK = graphql(`
  mutation Unbookmark($ids: [ID!]!) {
    unbookmark(ids: $ids) {
      id
      isBookmarked
    }
  }
`);
